import type { V3CanvasHomeFeaturedId, V3CanvasHomeFeaturedPlacement } from '$/domains/caseV3/type';

/** URL 仅携带精选主键和非默认投放位，不透传 API 数据或筛选参数。 */
export function getFeaturedRouteQuery(featuredId: V3CanvasHomeFeaturedId, placement?: V3CanvasHomeFeaturedPlacement) {
  return {
    featured_id: featuredId,
    ...(placement && placement !== 'website_home' ? { placement } : {}),
  };
}
